var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-actualizar-puestos"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Puestos")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return function() {
                    _vm.filterShow = _vm.filterShow ? false : true
                  }.apply(null, arguments)
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("filter_list")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Búsqueda/filtros")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              on: {
                click: function($event) {
                  return _vm.listarPuestos()
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filterShow,
                    expression: "filterShow"
                  }
                ],
                staticClass: "filter-container"
              },
              [
                _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                  _vm._v("search")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Puesto" },
                      on: {
                        input: function($event) {
                          return _vm.filterDenominacion(_vm.form.denominacion)
                        }
                      },
                      model: {
                        value: _vm.form.denominacion,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "denominacion", $$v)
                        },
                        expression: "form.denominacion"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Estado" },
                      on: {
                        input: function($event) {
                          return _vm.filterEstado(_vm.form.estado)
                        }
                      },
                      model: {
                        value: _vm.form.estado,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estado", $$v)
                        },
                        expression: "form.estado"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-filter" },
                  [
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "", small: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.recargar()
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("refresh")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Recargar filtros")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "" },
                            nativeOn: {
                              click: function($event) {
                                return function() {
                                  _vm.filterShow = false
                                  _vm.recargar()
                                }.apply(null, arguments)
                              }
                            },
                            slot: "activator"
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Cerrar filtros")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { slot: "activator", color: "primary", dark: "" },
              nativeOn: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.crearActualizarPuestos({})
                }
              },
              slot: "activator"
            },
            [
              _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
              _vm._v(" " + _vm._s(_vm.$t("common.add")))
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("nuevo")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-data-table",
                {
                  staticClass: "elevation-1",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.puestos,
                    "no-data-text": _vm.loading
                      ? "Cargando..."
                      : "No se tiene registros",
                    "disable-initial-sort": true,
                    loading: _vm.loading,
                    "no-results-text": "No se encontraron coincidencias",
                    "item-key": "id_puesto",
                    search: _vm.filters,
                    "custom-filter": _vm.customFilter,
                    "rows-per-page-items": [
                      20,
                      40,
                      { text: "Todos", value: -1 }
                    ]
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.denominacion))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.estado))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "nowrap text-xs-center" },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        icon: "",
                                        color: "rgb(87,51,204)",
                                        dark: ""
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.crearActualizarPuestos(
                                            items.item
                                          )
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("edit")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Editar registro")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        icon: "",
                                        color: "rgb(217,38,38)",
                                        dark: ""
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.eliminarPuesto(items.item)
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Eliminar registro")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                color: "primary",
                                dark: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.crearActualizarPuestos({})
                                }
                              },
                              slot: "activator"
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(" " + _vm._s(_vm.$t("common.add")))
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Agregar puesto")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6721c18e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6721c18e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/item_cargo_y_puesto/Puestos.vue
// module id = null
// module chunks = 